export default "/static/nocontent-1.png"